/* Alarde Parfums — interacción mínima, sin dependencias. */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const rutas = (window.alarde && window.alarde.rutas) || { carrito: "/cart", anadir: "/cart/add" };
  const formatoDinero = (centimos) =>
    new Intl.NumberFormat("es-ES", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" }).format(centimos / 100);

  /* ---------- Cajón móvil ---------- */
  const cajon = $("#cajon-menu");
  const abrir = $("[data-abrir-cajon]");
  const cerrar = $("[data-cerrar-cajon]");
  const setCajon = (v) => {
    if (!cajon) return;
    cajon.dataset.abierto = String(v);
    abrir && abrir.setAttribute("aria-expanded", String(v));
    document.documentElement.style.overflow = v ? "hidden" : "";
    (v ? cerrar : abrir)?.focus();
  };
  abrir?.addEventListener("click", () => setCajon(true));
  cerrar?.addEventListener("click", () => setCajon(false));
  cajon?.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setCajon(false);
    if (e.key !== "Tab") return;
    const f = $$("a, button", cajon);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- Buscador ---------- */
  const barra = $("#buscador-barra");
  $$("[data-abrir-buscador]").forEach((b) =>
    b.addEventListener("click", () => {
      const v = barra.dataset.abierto !== "true";
      barra.dataset.abierto = String(v);
      b.setAttribute("aria-expanded", String(v));
      if (v) $("input[type=search]", barra)?.focus();
    })
  );

  /* ---------- Envío automático (orden, filtros, cantidades del carrito) ---------- */
  $$("[data-auto-envio]").forEach((el) => el.addEventListener("change", () => el.form?.requestSubmit ? el.form.requestSubmit() : el.form?.submit()));
  $$("[data-filtros] input[type=checkbox]").forEach((el) => el.addEventListener("change", () => el.form.submit()));

  /* ---------- Contador del carrito ---------- */
  const pintarCuenta = (n) => {
    $$("[data-cuenta-carrito]").forEach((b) => { b.textContent = n; });
    $$("[data-cuenta-carrito-texto]").forEach((b) => (b.textContent = n));
  };

  /* ---------- Aviso de añadido ---------- */
  const aviso = $("#aviso-carrito");
  let avisoTimer;
  const mostrarAviso = (item) => {
    if (!aviso) return;
    $("[data-aviso-nombre]", aviso).textContent = item.product_title;
    const caja = $("[data-aviso-imagen]", aviso);
    caja.innerHTML = "";
    if (item.image) {
      const img = new Image();
      img.alt = "";
      img.src = item.image + (item.image.includes("?") ? "&" : "?") + "width=200";
      caja.appendChild(img);
    }
    aviso.dataset.visible = "true";
    clearTimeout(avisoTimer);
    avisoTimer = setTimeout(() => (aviso.dataset.visible = "false"), 4500);
  };
  // Pausa el cierre mientras el ratón o el foco están en el aviso
  aviso?.addEventListener("pointerenter", () => clearTimeout(avisoTimer));
  aviso?.addEventListener("pointerleave", () => (avisoTimer = setTimeout(() => (aviso.dataset.visible = "false"), 2000)));

  /* ---------- Cabecera: se aparta al bajar, vuelve al subir ---------- */
  const cabecera = $("[data-cabecera]");
  let ultimoY = scrollY;
  addEventListener("scroll", () => {
    if (!cabecera || document.documentElement.style.overflow === "hidden") return;
    const y = scrollY;
    if (Math.abs(y - ultimoY) < 6) return;
    cabecera.dataset.oculta = String(y > ultimoY && y > 240 && barra?.dataset.abierto !== "true");
    ultimoY = y;
  }, { passive: true });

  /* ---------- Formularios de compra (AJAX con respaldo normal) ---------- */
  $$("form[data-formulario-compra]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      const boton = $("[type=submit][name=add]", form);
      if (!window.fetch || !boton) return;
      e.preventDefault();
      const error = $("[data-error-compra]", form);
      boton.setAttribute("aria-busy", "true");
      boton.disabled = true;
      if (error) error.hidden = true;
      try {
        const r = await fetch(`${rutas.anadir}.js`, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        const datos = await r.json();
        if (!r.ok) throw new Error(datos.description || "No se ha podido añadir al carrito.");
        const carrito = await (await fetch(`${rutas.carrito}.js`)).json();
        pintarCuenta(carrito.item_count);
        mostrarAviso(datos.items ? datos.items[0] : datos);
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      } finally {
        boton.removeAttribute("aria-busy");
        boton.disabled = false;
      }
    });
  });

  /* ---------- Ficha de producto ---------- */
  const producto = $("[data-producto]");
  if (producto) {
    const variantes = JSON.parse($("[data-variantes]")?.textContent || "[]");
    const form = $("form[data-formulario-compra]", producto);
    const idInput = $("[data-id-variante]", producto);
    const boton = $("[data-boton-compra]", producto);
    const precio = $("[data-precio]", producto);
    const disponible = $("[data-disponible]", producto);
    const precioBarra = $("[data-precio-barra]");

    const actual = () => {
      const sel = $$("[data-opcion]:checked", producto).map((i) => i.value);
      return variantes.find((v) => v.options.every((o, i) => o === sel[i]));
    };
    const marcarAgotadas = () => {
      const sel = $$("[data-opcion]:checked", producto).map((i) => i.value);
      $$("[data-opcion]", producto).forEach((input) => {
        const pos = Number(input.dataset.opcion);
        const prueba = [...sel]; prueba[pos] = input.value;
        const v = variantes.find((x) => x.options.every((o, i) => o === prueba[i]));
        input.dataset.agotado = String(!v || !v.available);
      });
    };
    const actualizar = () => {
      const v = actual();
      marcarAgotadas();
      if (!v) {
        boton.disabled = true; $(".boton__texto", boton).textContent = "No disponible";
        disponible.textContent = "Esta combinación no existe"; disponible.dataset.estado = "agotado";
        return;
      }
      idInput.value = v.id;
      boton.disabled = !v.available;
      $(".boton__texto", boton).textContent = v.available ? "Añadir al carrito" : "Agotado";
      disponible.textContent = v.available ? "Disponible" : "Agotado";
      disponible.dataset.estado = v.available ? "disponible" : "agotado";
      precio.innerHTML = v.compare_at_price > v.price
        ? `<span>${formatoDinero(v.price)}</span> <s class="precio-antes">${formatoDinero(v.compare_at_price)}</s>`
        : `<span>${formatoDinero(v.price)}</span>`;
      if (precioBarra) precioBarra.textContent = formatoDinero(v.price);
      const url = new URL(location.href); url.searchParams.set("variant", v.id);
      history.replaceState(null, "", url);
      if (v.featured_media) cambiarImagen(v.featured_media.id);
    };
    $$("[data-opcion]", producto).forEach((i) => i.addEventListener("change", actualizar));
    if (variantes.length > 1) marcarAgotadas();

    // Cantidad
    $$(".cantidad", producto).forEach((c) => {
      const input = $("input", c);
      $("[data-menos]", c)?.addEventListener("click", () => (input.value = Math.max(1, (+input.value || 1) - 1)));
      $("[data-mas]", c)?.addEventListener("click", () => (input.value = (+input.value || 1) + 1));
    });

    // Galería: en móvil desliza con puntos; al cambiar de variante, va a su foto
    const pista = $("[data-galeria]", producto);
    const puntos = $$(".galeria__puntos span", producto);
    if (pista && puntos.length) {
      pista.addEventListener("scroll", () => {
        const i = Math.round(pista.scrollLeft / pista.clientWidth);
        puntos.forEach((p, n) => (p.dataset.activo = String(n === i)));
      }, { passive: true });
    }
    function cambiarImagen(mediaId) {
      const foto = mediaId && $(`[data-media-id="${mediaId}"]`, producto);
      if (!foto || !pista) return;
      if (pista.scrollWidth > pista.clientWidth) pista.scrollTo({ left: foto.offsetLeft - pista.offsetLeft, behavior: "smooth" });
      else foto.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }

    // Barra de compra móvil
    const barraCompra = $("[data-barra-compra]");
    if (barraCompra && boton && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => {
        barraCompra.dataset.visible = String(!en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(boton);
      $("[data-barra-boton]", barraCompra)?.addEventListener("click", () => form.requestSubmit ? form.requestSubmit(boton) : boton.click());
    }
  }

  /* ---------- Recomendaciones ---------- */
  const rel = $("[data-relacionados]");
  if (rel && rel.dataset.url && !rel.children.length) {
    fetch(rel.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nuevo = doc.querySelector("[data-relacionados]");
      if (nuevo && nuevo.innerHTML.trim()) rel.innerHTML = nuevo.innerHTML; else rel.remove();
    }).catch(() => rel.remove());
  }
})();
